import React, { Component } from "react";
import HolidayCard from "../../Components/Events/HolidayCard";
import { connect } from "react-redux";
import Header from "../../Components/MainLayout/Header";
import axios from "axios";
import noData from "../../Assets/img/noData.png";
import Skeleton from "react-loading-skeleton";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class Holidays extends Component {
  constructor(props) {
    super(props);
    this.state = {
      holiday_data: [],
      loading: true,
      fakeData: [1, 2, 3, 4],
    };
  }

  state = { holiday_data: [] };
  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Holidays";
    this.fetch({
      session: this.props?.user?.session?.id,
    });
  }

  fetch = (params = {}) => {
    axios
      .get(`/mApiV1/HolidayList`, {
        params: { ...params },
      })
      .then((res) => {
        this.setState({
          holiday_data: res.data,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
        });
      });
  };
  render() {
    const handelDt = (dt) => {
      var j = dt % 10,
        k = dt % 100;
      if (j === 1 && k !== 11) {
        return dt + "st";
      }
      if (j === 2 && k !== 12) {
        return dt + "nd";
      }
      if (j === 3 && k !== 13) {
        return dt + "rd";
      }
      return dt + "th";
    };
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    const handleDate = (date1, date2) => {
      let year1 = new Date(date1).getFullYear();
      let month1 = new Date(date1).getMonth();
      let dt1 = new Date(date1).getDate();

      let year2 = new Date(date2).getFullYear();
      let month2 = new Date(date2).getMonth();
      let dt2 = new Date(date2).getDate();

      year1 = year1 % 100;
      year2 = year2 % 100;
      if (year1 === year2) {
        if (month1 === month2) {
          if (dt1 === dt2) {
            return `${handelDt(dt1)} ${monthNames[month1]}, ${year1}`;
          } else {
            return `${handelDt(dt1)}-${handelDt(dt2)} ${
              monthNames[month1]
            }, ${year1}`;
          }
        } else {
          return `${handelDt(dt1)} ${monthNames[month1]} - ${handelDt(dt2)} ${
            monthNames[month2]
          }, ${year1}`;
        }
      } else {
        return `${handelDt(dt1)} ${monthNames[month1]}  ${year1} - ${handelDt(
          dt2
        )} ${monthNames[month2]}, ${year2}`;
      }
    };
    return (
      <React.Fragment>
        <Header to="/home" title="Holidays" />
        <div className="container pt-3">
          {this.state.loading
            ? this.state.fakeData?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="border p-3 shadow-sm rounded-lg mb-3"
                  >
                    <Skeleton />
                    <Skeleton width={200} />
                  </div>
                );
              })
            : null}

          {this.state.holiday_data.length !== 0 && this.state.loading === false
            ? this.state.holiday_data?.map((item, index) => (
                <div className="my-3" key={index}>
                  <HolidayCard
                    title={item.holidays_name}
                    dateDiff={handleDate(item.from_date, item.to_date)}
                    days={item.no_of_days}
                    description={item.description}
                  />
                </div>
              ))
            : null}

          {this.state.holiday_data.length === 0 &&
          this.state.loading === false ? (
            <div className="px-5 py-5">
              <img className="w-100 mt-5" src={noData} alt="No Data Found" />
              <p className="text-center th-14 th-bold mt-5">
                No Holidays Found!
              </p>
            </div>
          ) : null}
        </div>
      </React.Fragment>
    );
  }
}
export default connect(mapStateToProps)(Holidays);
